import theme01Img from "../assets/images/theme01.png";
import theme02Img from "../assets/images/theme02.png";
import theme03Img from "../assets/images/theme03.png";
import theme04Img from "../assets/images/theme04.png";
import theme05Img from "../assets/images/theme05.png";
import theme06Img from "../assets/images/theme06.png";
import theme07Img from "../assets/images/theme07.png";
import theme08Img from "../assets/images/theme08.png";
import theme09Img from "../assets/images/theme09.png";

export const categories = [
  {
    id: "all",
    label: "All",
    description: "View all designs and client websites",
  },
  {
    id: "website-designs",
    label: "Website Designs",
    description: "Available designs ready for customization",
  },
  {
    id: "recent-designs",
    label: "Recent Designs",
    description: "Recently completed",
  },
  {
    id: "recent-client-work",
    label: "Recent Client Work",
    description: "Recently completed client websites",
  },
  {
    id: "live-client-websites",
    label: "Live Client Websites",
    description: "Currently live",
  },
  {
    id: "coming-soon",
    label: "Coming Soon",
    description: "Website designs in progress",
  },
];

export const templatesData = [
  {
    id: 1,
    slug: "theme01",
    category: "website-designs",
    name: "Theme01",
    price: "$299",
    subtitle: "SEASALT CREATIVE TEMPLATE",
    tagline: "Luxe, Chic, Statement Making",
    img: theme01Img,
    badgeText: "TWO VERSIONS INCLUDED",
    viewDetailsUrl: "/details/theme01",
    demoRoute: "/websites/theme01",
    demoUrl: "https://delphine.pixandhue-demos.com/",
    externalUrl: "https://delphine.pixandhue-demos.com/",
    reviewsCount: 38,
    pagesIncluded: [
      "Start Here",
      "About Me",
      "Experience",
      "Investment",
      "Blog",
      "Contact",
      "Link Pages",
      "Testimonials",
      "FAQs",
      "Sales Page"
    ],
    bonusPages: [
      "Shop",
      "Portfolio",
      "Single Project",
      "Galleries",
      "Coming Soon",
      "Opt-in Long",
      "Opt-in",
      "Thank You"
    ],
    navMenu: [
      { label: "START HERE" },
      { label: "ABOUT ME" },
      { label: "EXPERIENCE" },
      { label: "PAGES", dropdown: ["INVESTMENT", "BLOG", "CONTACT", "LINKS PAGE", "TESTIMONIALS", "FAQ", "SALES PAGE"] },
      { label: "PRO PAGES", dropdown: ["SHOP", "PORTFOLIO", "SINGLE PROJECT", "GALLERIES", "COMING SOON", "OPT-IN LONG", "OPT-IN", "THANK YOU"] }
    ]
  },
  {
    id: 2,
    slug: "theme02",
    category: "website-designs",
    name: "Theme02",
    price: "$299",
    subtitle: "SEASALT CREATIVE TEMPLATE",
    tagline: "Minimal, Ethereal, Editorial",
    img: theme02Img,
    badgeText: "TWO VERSIONS INCLUDED",
    viewDetailsUrl: "/details/theme02",
    demoRoute: "/websites/theme02",
    demoUrl: "https://emilia.pixandhue-demos.com/",
    externalUrl: "https://emilia.pixandhue-demos.com/",
    reviewsCount: 24,
    pagesIncluded: [
      "Home",
      "About",
      "Experience",
      "Offerings",
      "Inquire"
    ],
    bonusPages: [
      "Blog",
      "Portfolio",
      "Gallery",
      "FAQ",
      "Contact",
      "Education"
    ],
    navMenu: [
      { label: "HOME" },
      { label: "ABOUT" },
      { label: "EXPERIENCE" },
      { label: "OFFERINGS" },
      { label: "LAYOUTS", dropdown: ["BLOG", "PORTFOLIO", "GALLERY", "FAQ", "CONTACT", "EDUCATION"] },
      { label: "INQUIRE", isCta: true }
    ]
  },
  {
    id: 3,
    slug: "theme03",
    category: "recent-designs",
    name: "Theme03",
    price: "$299",
    subtitle: "SEASALT CREATIVE TEMPLATE",
    tagline: "Romantic, Organic, Fine Art",
    img: theme03Img,
    badgeText: "TWO VERSIONS INCLUDED",
    viewDetailsUrl: "/details/theme03",
    demoRoute: "/websites/theme03",
    demoUrl: "https://demoshirley.lovelyconfetti.com/",
    externalUrl: "https://demoshirley.lovelyconfetti.com/",
    reviewsCount: 19,
    pagesIncluded: [
      "Home",
      "About",
      "Blog",
      "Contact",
      "Shop",
      "Get Started"
    ],
    bonusPages: [
      "Services",
      "Experience",
      "Resources",
      "Mentoring",
      "Galleries",
      "Gallery Page",
      "Portfolio Filter",
      "Instagram Page",
      "Lead Magnet",
      "Thank You",
      "Coming Soon",
      "404 Page"
    ],
    navMenu: [
      { label: "HOME" },
      { label: "ABOUT" },
      { label: "BLOG" },
      { label: "PAGES", dropdown: ["SERVICES", "EXPERIENCE", "RESOURCES", "MENTORING", "GALLERIES", "GALLERY PAGE", "PORTFOLIO FILTER", "INSTAGRAM PAGE", "LEAD MAGNET", "THANK YOU", "COMING SOON", "404 PAGE"] },
      { label: "CONTACT" },
      { label: "SHOP" },
      { label: "GET STARTED", isCta: true }
    ]
  },
  {
    id: 4,
    slug: "theme04",
    category: "recent-client-work",
    name: "Theme04",
    price: "$299",
    subtitle: "SEASALT CREATIVE TEMPLATE",
    tagline: "Bold, Atmospheric, Modern",
    img: theme04Img,
    badgeText: "TWO VERSIONS INCLUDED",
    viewDetailsUrl: "/details/theme04",
    demoRoute: "/websites/theme04",
    externalUrl: "https://thekeyleigh.pixandhue-demos.com/",
    demoUrl: "https://thekeyleigh.pixandhue-demos.com/",
    reviewsCount: 42,
    pagesIncluded: [
      "Home",
      "About",
      "Experience",
      "Offering",
      "Inquire"
    ],
    bonusPages: [
      "Blog",
      "Contact",
      "Portfolio",
      "Gallery",
      "FAQ",
      "Education"
    ],
    navMenu: [
      { label: "HOME" },
      { label: "ABOUT" },
      { label: "EXPERIENCE" },
      { label: "OFFERING" },
      { label: "LAYOUTS", dropdown: ["BLOG", "CONTACT", "PORTFOLIO", "GALLERY", "FAQ", "EDUCATION"] },
      { label: "INQUIRE", isCta: true }
    ]
  },
  {
    id: 5,
    slug: "theme05",
    category: "live-client-websites",
    name: "Theme05",
    price: "$299",
    subtitle: "SEASALT CREATIVE TEMPLATE",
    tagline: "Sophisticated, Timeless, High End",
    img: theme05Img,
    badgeText: "TWO VERSIONS INCLUDED",
    viewDetailsUrl: "/details/theme05",
    demoRoute: "/websites/theme05",
    demoUrl: "https://ashlyn.pixandhue-demos.com/",
    externalUrl: "https://ashlyn.pixandhue-demos.com/",
    reviewsCount: 15,
    pagesIncluded: [
      "Home",
      "About",
      "Experience",
      "Offering"
    ],
    bonusPages: [
      "Blog",
      "Contact",
      "Portfolio",
      "Gallery",
      "FAQ"
    ],
    navMenu: [
      { label: "HOME" },
      { label: "ABOUT" },
      { label: "EXPERIENCE" },
      { label: "OFFERING" },
      { label: "LAYOUTS", dropdown: ["BLOG", "CONTACT", "PORTFOLIO", "GALLERY", "FAQ"] }
    ]
  },
  {
    id: 6,
    slug: "theme06",
    category: "recent-designs",
    name: "Theme06",
    price: "$299",
    subtitle: "SEASALT CREATIVE TEMPLATE",
    tagline: "Warm, Editorial, Poetic",
    img: theme06Img,
    badgeText: "TWO VERSIONS INCLUDED",
    viewDetailsUrl: "/details/theme06",
    demoRoute: "/websites/theme06",
    externalUrl: "https://maeve.pixandhue-demos.com/",
    demoUrl: "https://maeve.pixandhue-demos.com/",
    reviewsCount: 29,
    pagesIncluded: [
      "Home",
      "Offerings",
      "About Me",
      "Experience",
      "Contact",
      "Link Page",
      "Blog",
      "Galleries"
    ],
    bonusPages: [
      "Single Project",
      "Portfolio",
      "Coming Soon",
      "Sales",
      "FAQ",
      "Testimonials",
      "Opt-in",
      "Opt-in Long",
      "Thank You"
    ],
    navMenu: [
      { label: "HOME" },
      { label: "OFFERINGS" },
      { label: "ABOUT ME" },
      { label: "LAYOUTS", dropdown: ["EXPERIENCE", "CONTACT", "LINK PAGE", "BLOG", "GALLERIES", "SINGLE PROJECT", "PORTFOLIO", "COMING SOON"] },
      { label: "SALES", dropdown: ["SALES", "FAQ", "TESTIMONIALS", "OPT-IN", "OPT-IN LONG", "THANK YOU"] }
    ]
  },
  {
    id: 7,
    slug: "theme07",
    category: "website-designs",
    name: "Theme07",
    price: "$299",
    subtitle: "SEASALT CREATIVE TEMPLATE",
    tagline: "Artistic, Luminous, Contemporary",
    img: theme07Img,
    badgeText: "TWO VERSIONS INCLUDED",
    viewDetailsUrl: "/details/theme07",
    demoRoute: "/websites/theme07",
    externalUrl: "https://morgan.pixandhue-demos.com/",
    demoUrl: "https://morgan.pixandhue-demos.com/",
    reviewsCount: 21,
    pagesIncluded: [
      "Home",
      "Offerings",
      "Experience",
      "About Me",
      "Blog",
      "Free Gallery",
      "Portfolio",
      "Contact",
      "FAQ",
      "Link Page"
    ],
    bonusPages: [
      "Pro Gallery",
      "Pro Portfolio",
      "Portfolio Item",
      "Prop",
      "Sales Page",
      "Coming Soon",
      "Opt-in Long",
      "Opt-in"
    ],
    navMenu: [
      { label: "HOME" },
      { label: "OFFERINGS" },
      { label: "EXPERIENCE" },
      { label: "PAGES", dropdown: ["ABOUT ME", "BLOG", "FREE GALLERY", "PORTFOLIO", "CONTACT", "FAQ", "LINK PAGE"] },
      { label: "PRO PAGES", dropdown: ["PRO GALLERY", "PRO PORTFOLIO", "PORTFOLIO ITEM", "PROP", "SALES PAGE", "COMING SOON", "OPT-IN LONG", "OPT-IN"] }
    ]
  },
  {
    id: 8,
    slug: "theme08",
    category: "website-designs",
    name: "Theme08",
    price: "$299",
    subtitle: "SEASALT CREATIVE TEMPLATE",
    tagline: "Storytelling, Warm, Authentic",
    img: theme08Img,
    badgeText: "TWO VERSIONS INCLUDED",
    viewDetailsUrl: "/details/theme08",
    demoRoute: "/websites/theme08",
    externalUrl: "https://lightromance.kreativeavenuedesigns.com/",
    demoUrl: "https://lightromance.kreativeavenuedesigns.com/",
    reviewsCount: 31,
    pagesIncluded: [
      "Home",
      "About",
      "Portfolio",
      "Blog",
      "FAQ",
      "Information",
      "Contact"
    ],
    bonusPages: [
      "Wedding Guide",
      "Gallery 1",
      "Category Archive",
      "Links",
      "Coming Soon"
    ],
    navMenu: [
      { label: "HOME" },
      { label: "ABOUT" },
      { label: "PORTFOLIO" },
      { label: "PAGE TEMPLATES", dropdown: ["WEDDING GUIDE", "GALLERY 1", "CATEGORY ARCHIVE", "LINKS", "COMING SOON"] },
      { label: "BLOG" },
      { label: "FAQ" },
      { label: "INFORMATION" },
      { label: "CONTACT" }
    ]
  },
  {
    id: 9,
    slug: "theme09",
    category: "recent-client-work",
    name: "Theme09",
    price: "$299",
    subtitle: "SEASALT CREATIVE TEMPLATE",
    tagline: "Adventurous, Free-spirited, Fine Art",
    img: theme09Img,
    badgeText: "TWO VERSIONS INCLUDED",
    viewDetailsUrl: "/details/theme09",
    demoRoute: "/websites/theme09",
    externalUrl: "https://sophia.crvhr.co/",
    demoUrl: "https://sophia.crvhr.co/",
    reviewsCount: 17,
    pagesIncluded: [
      "Home",
      "About",
      "Blog",
      "Contact"
    ],
    bonusPages: [
      "Form Submitted",
      "Portfolio",
      "Link in Bio",
      "Services",
      "Single Service"
    ],
    navMenu: [
      { label: "HOME" },
      { label: "ABOUT" },
      { label: "PAGES", dropdown: ["FORM SUBMITTED", "PORTFOLIO", "LINK IN BIO", "SERVICES", "SINGLE SERVICE"] },
      { label: "BLOG" },
      { label: "CONTACT" }
    ]
  },
];
